import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveConfigs($ids: [Int]) {
    removeConfigs(ids: $ids)
  }
`

export const useRemoveConfigs = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Configs', 'Config', 'ConfigsCount'],
    client: generalClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
